import { request } from "../network/request";
const db = "dn0";

export function getRewardList(params) {
    return request({
        url: "pmp/reward/list",
        method: "post",
        data: {
            db,
            ...params,
        },
    });
}

export function exportRewardList(params) {
    return request({
        url: "pmp/reward/exportRewardList",
        method: "post",
        data: {
            db,
            ...params,
        },
    });
}

export function getselector(taskId) {
    return request({
        url: "pmp/reward/selector",
        method: "get",
        params: {
            taskId
        }
    });
}

export function getRlDetail(rlId, taskId) {
    return request({
        url: "pmp/reward/RlDetail",
        method: "get",
        params: {
            rlId,
            taskId
        }
    });
}

export function insertReward(params) {
    return request({
        url: "pmp/reward/insertReward",
        method: "post",
        data: params
    });
}

export function updateReward(params) {
    return request({
        url: "pmp/reward/updateReward",
        method: "post",
        data: params
    });
}

export function getcgwDetail(rlId, ygbh) {
    return request({
        url: "pmp/reward/getcgwDetail",
        method: "get",
        params: {
            rlId,
            ygbh
        }
    });
}